import { setSavingOverlayText } from 'redux/actions/saving-overlay';
import store from 'redux/store';
import { NovoAIItemType } from 'redux/schemas/models/lecture-page';
import {
  resetLeftPanelNovoAI,
  setLeftPanelView,
  setDestinationLecturePage,
  setNovoAIShowPreviewModal,
  patchSuggestedComponentSet,
  resetAiSuggestComponentsState,
  setNovoAIShowGenerateModal,
  setAddingSuggestedComponentSetId,
} from 'redux/actions/lecture-pages';
import { LeftPanelView } from 'redux/schemas/app/lecture-page';
import {
  changeDisableButtonState,
  openConfirmationDialog,
  closeConfirmationDialog,
} from 'redux/actions/confirmation-dialogs';
import { isUndefined, pick, isEmpty } from 'underscore';
import { LecturePageMode } from 'lecture_pages/components';
import uuid from 'react-uuid';
import { hideAddUI } from 'lecture_pages/templates/components/nv-add-component';
import t from '../../react-translate';
import { useAngularPreventLecturePageNavigation } from '../hooks/use-prevent-lecture-page-navigation';
import DiscussionBody from '../components/discussion-body.tsx';

/* @ngInject */
export default function DiscussionFormModalController(
  $uibModalInstance,
  $window,
  $stateParams,
  $scope,
  $timeout,
  _,
  config,
  ConfirmationOverlays,
  CurrentUserManager,
  CurrentCourseManager,
  DiscussionsManager,
  StateManager,
  TeamDiscussionLectureComponentModel,
  DiscussionLectureComponentModel,
  vmResolves,
) {
  const SELECT_COURSE_OR_TEAM = 'SELECT_COURSE_OR_TEAM';
  const SELECT_COURSE_DISCUSSION = 'SELECT_COURSE_DISCUSSION';
  const SELECT_TEAM_DISCUSSION = 'SELECT_TEAM_DISCUSSION';
  const SELECT_TEAM_FORMATION = 'SELECT_TEAM_FORMATION';

  const vm = this;
  vm.config = config;
  vm.currentState = SELECT_COURSE_OR_TEAM;
  vm.isContentManagementCollection = CurrentCourseManager.course.isContentManagementCollection;
  vm.selectedState = vm.isContentManagementCollection ? SELECT_COURSE_DISCUSSION : SELECT_COURSE_OR_TEAM;
  vm.courseDiscussionPendoTagName = vm.isContentManagementCollection
    ? config.pendo.lectureEdit.lessonLibrary.courseDiscussion
    : config.pendo.lectureEdit.courseDiscussion;

  vm.discussionStarter = {
    new: null,
    current: null,
  };

  _.extend(vm, vmResolves);
  let dismissedByUser = false;

  vm.CurrentUserManager = CurrentUserManager;
  vm.CurrentCourseManager = CurrentCourseManager;
  vm.isLinked = vm.lectureComponent?.lecturePage?.isLinked;

  vm.getTopicsAndMembers = () => {
    DiscussionsManager.initialize({ catalogId: $stateParams.catalogId });

    // Collection discussion does not use the topic dropdown, so there's no need to retrieve the list
    if (!vm.isContentManagementCollection) {
      DiscussionsManager.getAllTopics(null, { nameList: true })
        .then(() => {
          if (vm.postDraft.topicId) {
            if (vm.postDraft.topic && vm.postDraft.topic?.id !== vm.postDraft.topicId) {
              vm.postDraft.topicId = vm.postDraft.topic.id;
              vm.postDraft.forumId = vm.postDraft.topic.id;
            }
            vm.postDraft.topic = DiscussionsManager.findTopic(vm.postDraft.topicId);
          }
        });
    }

    CurrentCourseManager.course.getTeachingTeamMembers()
      .then(() => {
        if (CurrentCourseManager.course.teachingTeamMembers) {
          if (!vm.postDraft.starterId) {
            vm.postDraft.starterId = CurrentUserManager.user.id;
            vm.postDraft.user = CurrentUserManager.user;
          }

          vm.discussionStarterOptions = _.pluck(_.clone(CurrentCourseManager.course.teachingTeamMembers), 'user');

          // if the original starter isn't already in the list, add
          if (!_.findWhere(vm.discussionStarterOptions, { id: vm.postDraft.user.id })) {
            vm.discussionStarterOptions.unshift(vm.postDraft.user);
          }

          // if the current user isn't in the list, add
          if (!_.findWhere(vm.discussionStarterOptions, { id: CurrentUserManager.user.id })) {
            vm.discussionStarterOptions.unshift(vm.CurrentUserManager.user);
          }
        }
      });
  };

  vm.selectTeamDiscussion = () => {
    vm.selectedState = SELECT_TEAM_DISCUSSION;
  };

  vm.selectCourseDiscussion = () => {
    vm.selectedState = SELECT_COURSE_DISCUSSION;
  };

  vm.switchToTeamDiscussionForm = () => {
    vm.currentState = SELECT_TEAM_DISCUSSION;
  };

  vm.selectTopic = (topic) => {
    if (topic) {
      vm.postDraft.topic = topic;
    } else {
      vm.postDraft.topic = {
        isNewTopic: true,
      };
    }

    vm.discussionForm.$setValidity('selectedTopic', true);
    vm.discussionForm.$setDirty();
  };

  vm.selectTeamFormation = (formedByStudents) => {
    vm.postDraft.formedByStudents = formedByStudents;
    vm.editTeamFormationTypeForm.$setDirty();
  };

  vm.changeDiscussionStarter = function (newDiscussionStarterUser) {
    vm.postDraft.starterId = newDiscussionStarterUser.id;
    const lectureComponentDocumentDom = angular.element(document.querySelector(`#lecture-component-${vm.lectureComponent.id}`));
    const lectureComponentDocumentDomPositionY = lectureComponentDocumentDom[0].offsetTop;
    const SECTIONS_HEIGHT = 230;
    const scrollToOffset = lectureComponentDocumentDomPositionY - SECTIONS_HEIGHT;
    vm.lectureComponent.setInitialScrollTopDiscussionStarter(scrollToOffset);

    vm.discussionStarter = {
      new: newDiscussionStarterUser,
      current: vm.postDraft.user,
    };
    if (vm.discussionStarter.new && vm.discussionStarter.new.id !== vm.discussionStarter.current.id) {
      vm.discussionForm.$setDirty();
    }
  };

  vm.findDiscussionStarterById = function (userId) {
    return _.findWhere(vm.discussionStarterOptions, { id: userId });
  };

  vm.filterTopicOptions = function () {
    return _.filter(DiscussionsManager.allTopics, (topic) => topic.id > 0);
  };

  vm.chooseDiscussion = () => {
    vm.currentState = vm.selectedState;

    let Model;
    if (vm.currentState === SELECT_TEAM_DISCUSSION) {
      Model = TeamDiscussionLectureComponentModel;
      $timeout(() => {
        vm.discussionForm.$setValidity('selectedTopic', true);
      });
    } else {
      Model = DiscussionLectureComponentModel;
      $timeout(() => {
        /**
         * SelectedTopic is not using in collection lesson. So setting the value
         * based on the iscollection field
         */
        vm.discussionForm.$setValidity('selectedTopic', vm.isContentManagementCollection);
      });
    }

    if (!CurrentCourseManager.course.hasCourseLongTeamSet && vm.currentState === SELECT_TEAM_DISCUSSION) {
      vm.currentState = SELECT_TEAM_FORMATION;
    }

    const component = new Model({}, false, true);
    vm.lectureComponent.setDiscussion(component);
    vm.postDraft = vm.lectureComponent.realComponent.postDraft;
    vm.getTopicsAndMembers();
  };

  vm.saveDiscussion = () => {
    dismissedByUser = true;

    if (
      vm.lectureComponent?.realComponent?.type === 'TeamDiscussionLectureComponent'
      && vm.workflowCtx.mode === 'new'
      && !CurrentCourseManager.course.hasCourseLongTeamSet
    ) {
      store.dispatch(setSavingOverlayText(
        t.LECTURE_PAGES.COMPONENTS.TEAM_DISCUSSION.TEAM_FORMATION_AND_TEAM_DISCUSSION_ADDING(CurrentCourseManager.course.getAliases()),
      ));
    }

    if (!vm.postDraft.highlightedNow) {
      vm.postDraft.highlightedFrom = null;
      vm.postDraft.highlightedTo = null;
    }

    // If we're updating the Discussion through the Regeneration, we should:
    // 1. Reset the NovoAI data
    // 2. Reset the panel view
    // 3. Reset the flag that indicates the regeneration status
    if (vm.lectureComponent.isRegenerating) {
      store.dispatch(resetLeftPanelNovoAI());
      store.dispatch(setLeftPanelView(LeftPanelView.OUTLINE));
      vm.lectureComponent.isRegenerating = false;
    }

    $uibModalInstance.close();
  };

  vm.save = () => {
    if (vm.discussionStarter.new && vm.discussionStarter.new.id !== vm.discussionStarter.current.id) {
      store.dispatch(openConfirmationDialog({
        icon: 'warning',
        title: t.DISCUSSIONS.BULK_STARTER_UPDATE.TITLE(),
        bodyText: <DiscussionBody
          currentDiscussionStarterUser={vm.discussionStarter.current}
          newDiscussionStarterUser={vm.discussionStarter.new}
          onChange={(e) => {
            store.dispatch(changeDisableButtonState(false));
            vm.lectureComponent.setUpdatedDiscussionStarter(e);
          }}
        />,
        confirmText: t.DISCUSSIONS.BULK_STARTER_UPDATE.OK_BUTTON(),
        confirmButtonDisabled: isUndefined(vm.lectureComponent.shouldBulkUpdateDiscussionStarter),
        confirmButtonVariant: 'danger',
        onCancel: () => {
          vm.lectureComponent.setUpdatedDiscussionStarter(undefined);
        },
        cancelText: t.DISCUSSIONS.BULK_STARTER_UPDATE.CANCEL_BUTTON(),
        shouldWaitForConfirmation: true,
        onConfirm: () => {
          vm.saveDiscussion();
          // Look for the dialog element and observe it for removal
          const dialogElement = document.querySelector('div[role="dialog"]');
          if (dialogElement) {
            // We need to observe the dialog element for removal and dispatch the closeConfirmationDialog action
            const observer = new MutationObserver(() => {
              if (!document.body.contains(dialogElement)) {
                // The dialog has been removed, so we can disconnect the observer
                observer.disconnect();
                store.dispatch(closeConfirmationDialog());
              }
            });

            observer.observe(document.body, { childList: true, subtree: true });
          }
        },
      }));
    } else {
      const state = store.getState();
      const { itemType, lectureComponentToReplace } = state.app.lecturePage.novoAI;

      // Using the NovoAI creation workflow when creating a discussion through that workflow.
      if (isEmpty(lectureComponentToReplace) && itemType === NovoAIItemType.DISCUSSION) {
        /**
         * Adding the discussion data to the Suggested Activities Redux key and
         * using component location selection and saving within the NovoAi workflow.
         */
        const componentSetId = uuid();
        store.dispatch(patchSuggestedComponentSet({
          id: componentSetId,
          secondaryActivities: [],
          activity: {
            ...pick(vm.lectureComponent, 'trueType', 'type'),
            topic: {
              ...pick(vm.lectureComponent.postDraft, 'title', 'body', 'starterId', 'expandedOnLoad'),
              forumId: vm.lectureComponent.postDraft.topic.id,
              forum: { title: vm.lectureComponent.postDraft.topic.title },
            },
          },
        }));

        // Hide the discussion modal visually before opening the pick-location
        // preview to prevent it from peeking out behind/below when the post body
        // is long. We cannot call dismiss() here because that triggers
        // closeAiGeneration() which would tear down the entire NovoAI flow.
        const discussionModal = $window.document.querySelector('.discussion-lecture-component-modal');
        if (discussionModal) {
          discussionModal.style.display = 'none';
        }
        const modalBackdrop = $window.document.querySelector('.modal-backdrop');
        if (modalBackdrop) {
          modalBackdrop.style.display = 'none';
        }

        // Using the NovoAI flow lesson preview to pick a location for the discussion.
        store.dispatch(setDestinationLecturePage({
          mode: LecturePageMode.VIEW,
          lecturePageId: $stateParams.id,
          catalogId: $stateParams.catalogId,
        }));

        store.dispatch(setAddingSuggestedComponentSetId(componentSetId));
        store.dispatch(setNovoAIShowPreviewModal(true));
      } else {
        vm.saveDiscussion();
      }
    }
  };

  vm.cancel = () => {
    if (
      vm.editMode
      || [
        NovoAIItemType.DISCUSSION,
        NovoAIItemType.SUGGEST_ACTIVITIES,
      ].includes(vm.lectureComponent.aiOrigin)
    ) {
      $uibModalInstance.dismiss();
    } else if (vm.currentState === SELECT_TEAM_DISCUSSION && !CurrentCourseManager.course.hasCourseLongTeamSet) {
      vm.lectureComponent.createDraft();
      vm.currentState = SELECT_TEAM_FORMATION;
    } else {
      vm.lectureComponent.createDraft();
      vm.currentState = SELECT_COURSE_OR_TEAM;
    }
  };

  const hasUnsavedChanges = () => {
    const state = store.getState();
    const novoAIItemType = state.app.lecturePage.novoAI?.itemType;

    // The unsaved changes warning is not required in the Novo AI discussion flow.
    return (
      novoAIItemType !== NovoAIItemType.DISCUSSION
      && vm.discussionForm && (vm.discussionForm.$dirty
        || (vm.postDraft?.topic && vm.postDraft.topic.id !== vm.postDraft.forumId)
        || (vm.postDraft && vm.postDraft.user?.id !== vm.postDraft.starterId))
    );
  };

  const checkUnsavedChanges = () => hasUnsavedChanges();

  useAngularPreventLecturePageNavigation($scope, checkUnsavedChanges);

  // warn if leaving the modal and have unsaved changes
  vm.deregisterStateChangeStart = StateManager.registerStateChangeStart(checkUnsavedChanges,
    'discussions/templates/nv-unsaved-changes-confirmation-overlay.html',
    'FORM.NAVIGATE_AWAY.CLOSE_WINDOW',
    undefined,
    undefined,
    () => {
      vm.deregisterModalClosing?.();

      $uibModalInstance.dismiss();
    });

  // Closing the AI generation flow and modals when the activity uses the NovoAI flow.
  vm.closeAiGeneration = () => {
    const state = store.getState();
    const novoAIItemType = state.app.lecturePage.novoAI?.itemType;

    if (novoAIItemType === NovoAIItemType.DISCUSSION) {
      store.dispatch(setNovoAIShowGenerateModal(false));
      store.dispatch(resetAiSuggestComponentsState());
      hideAddUI(store.dispatch);
    }
  };

  vm.deregisterModalClosing = $scope.$on('modal.closing', ($event) => {
    if (hasUnsavedChanges() && !dismissedByUser) {
      $event.preventDefault();

      const modalOverlay = ConfirmationOverlays.openConfirmationModal('discussions/templates/nv-unsaved-changes-confirmation-overlay.html');

      modalOverlay.result.then(() => {
        dismissedByUser = true;
        $uibModalInstance.dismiss();
        if (vm.lectureComponent?.createDraft) {
          vm.lectureComponent.createDraft();
        }

        vm.closeAiGeneration();
      });
    } else {
      vm.closeAiGeneration();
    }
  });

  // Update the modal title to match the current page view
  $scope.$watch('vm.currentState', () => {
    let title = null;

    switch (vm.currentState) {
      case SELECT_COURSE_OR_TEAM:
        if (!vm.lectureComponent.id) {
          title = t.LECTURE_PAGES.COMPONENTS.DISCUSSION.ADD_DISCUSSION;
        } else {
          title = t.LECTURE_PAGES.COMPONENTS.DISCUSSION.EDIT_DISCUSSION;
        }
        break;
      case SELECT_COURSE_DISCUSSION:
        if (!vm.lectureComponent.id) {
          title = t.LECTURE_PAGES.COMPONENTS.COURSE_DISCUSSION.MODAL_TITLE.CREATE;
        } else {
          title = t.LECTURE_PAGES.COMPONENTS.COURSE_DISCUSSION.MODAL_TITLE.EDIT;
        }
        break;
      case SELECT_TEAM_DISCUSSION:
        if (!vm.lectureComponent.id) {
          title = t.LECTURE_PAGES.COMPONENTS.TEAM_DISCUSSION.MODAL_TITLE.CREATE;
        } else {
          title = t.LECTURE_PAGES.COMPONENTS.TEAM_DISCUSSION.MODAL_TITLE.EDIT;
        }
        break;
      case SELECT_TEAM_FORMATION:
        title = t.LECTURE_PAGES.COMPONENTS.EXERCISE.MODAL.TEAM_TYPE.TITLE.ADD_TEAM_FORMATION;
        break;
      default:
        return;
    }

    if (vm.workflowCtx) {
      vm.workflowCtx.setSettings({
        ...vm.workflowCtx.settings,
        title: (mode, courseAliases) => title(courseAliases),
      });
    }
  });

  $scope.$on('$destroy', () => {
    angular.element($window).off('beforeunload');
    vm.deregisterStateChangeStart?.();
  });

  // Entry point when editing an existing discussion or crating an AI-generated discussion
  if (vm.lectureComponent.type !== 'AbstractDiscussionLectureComponent') {
    vm.postDraft = vm.lectureComponent.postDraft;
    vm.getTopicsAndMembers();

    // Updating the current state whether the discussion was marked as a team discussion or course-wide discussion
    if (vm.lectureComponent.type === 'TeamDiscussionLectureComponent') {
      vm.currentState = SELECT_TEAM_DISCUSSION;
    } else {
      vm.currentState = SELECT_COURSE_DISCUSSION;
    }

    // Setting the required params when editing an existing discussion
    if (vm.lectureComponent.aiOrigin !== NovoAIItemType.DISCUSSION || vm.lectureComponent.isRegenerating) {
      vm.editMode = true;
      vm.postDraft.starterId = vm.postDraft.user.id;
    }

    if (vm.lectureComponent.isRegenerating) {
      $timeout(() => {
        vm.discussionForm.$setDirty();
      });
    }
  }
}
